import { THUMB_CARD_SIZE } from '../../../../../../../../const';

export const MIME_TYPE_GOOGLE_APPS = 'google-apps';
export const DRIVE_DOC_GOOGLE_THUMB_SIZE = `w${THUMB_CARD_SIZE}`;
